import React, { memo, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import WarningFilledIcon from 'transfix-icons/build/WarningFilledIcon'
import { Button } from 'transfix-ui/components/Button'
import RadialSpinner from 'transfix-ui/components/RadialSpinner'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { useELDIntegration, useFMSRoutes } from 'apps/fleet-planner/hooks'
import { IconWrapper } from 'transfix-ui'

const useEldIntegrationCallbackPageStyles = makeStyles({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inner: {
    display: 'block',
    textAlign: 'center',
  },
})

/**
 * Page that renders and receives auth callback from KeepTruckin oAuth
 */
export const EldIntegrationCallbackPage = memo(() => {
  const [hasError, setHasError] = useState<boolean>(false)
  const { authCallbackHandler } = useELDIntegration()

  /**
   * When page loads, trigger post request with
   * token value
   */
  const hasTriggered = useRef(false)
  useEffect(() => {
    async function authHandler() {
      hasTriggered.current = true
      const res = await authCallbackHandler()

      // if res is false, set error to true
      setHasError(!res)
    }

    if (!hasTriggered.current) {
      authHandler()
    }
  }, [authCallbackHandler])

  const classes = useEldIntegrationCallbackPageStyles()

  const history = useFMSRoutes()

  const clickHandler = () => {
    history.push('/user/settings/integrations')
  }

  return (
    <Box className={classNames(classes.root, 'fadeInUp')}>
      {hasError ? (
        <Box className={classes.inner}>
          <Box mb={1}>
            <IconWrapper
              Icon={WarningFilledIcon}
              color='centerline'
              size='xxlarge'
              BoxProps={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            />
          </Box>
          <Typography variant='h3' component='div' align='center'>
            There was an error connecting your KeepTruckin account.
          </Typography>
          <Box p={2}>
            <Button onClick={clickHandler}>Go to Settings Page</Button>
          </Box>
        </Box>
      ) : (
        <Box className={classes.inner}>
          <Box mb={1}>
            <RadialSpinner position='relative' />
          </Box>
          <Typography variant='h3' component='div' align='center'>
            Connecting your KeepTruckin account&hellip;
          </Typography>
        </Box>
      )}
    </Box>
  )
})
